import { CommonModule } from '@angular/common';
import {
  AfterViewChecked,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  HostListener,
  inject,
  REQUEST,
  signal,
} from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { NavigationEnd, Router, RouterOutlet } from '@angular/router';
import { LoadingBarModule } from '@ngx-loading-bar/core';
import { NgxSpinnerModule } from 'ngx-spinner';
import { AuthGuardService } from './core/services/auth/auth-guard.service';
import { SpinnerService } from './core/services/spinner.service';
import { GoTopComponent } from './shared/components/go-top/go-top.component';
import { AuthModalComponent } from './shared/components/modals/auth-modal/auth-modal.component';
import { InputsModule } from './shared/modules/inputs/inputs.module';
import { SharedModule } from './shared/shared-module';
import { NavComponent } from './layouts/shared/components/nav/nav.component';
import { FooterComponent } from './layouts/shared/components/footer/footer.component';
import { AdsenseService } from './core/services/adsense.service';
import { AdBlockerDetectionComponent } from './shared/components/ads/ad-blocker-detection/ad-blocker-detection.component';
import { environment } from '../environments/environment';
import { PlatformService } from './core/services/platform.service';
import { CookieBannerComponent } from './shared/components/cookie-banner/cookie-banner.component';

@Component({
  selector: 'po-root',
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,

  imports: [
    NavComponent,
    FooterComponent,
    // CookieModule,
    GoTopComponent,
    CommonModule,
    // RouterOutlet,
    InputsModule,
    NgxSpinnerModule,
    // ReactiveFormsModule,
    LoadingBarModule,
    AuthModalComponent,
    SharedModule,
    AdBlockerDetectionComponent,
    CookieBannerComponent
  ],
})
export class AppComponent implements AfterViewChecked {
  isAllowFooter = signal(false);
  constructor(
    public spinner: SpinnerService,
    public authGuardService: AuthGuardService,
    private router: Router,
    public adsenseService: AdsenseService,
    private pt: PlatformService,
  ) {
    // if (pt.isBrowser) {
    //   environment.front.host = window.location.host;
    //   environment.front.href = window.location.origin;
    // }
  }

  ngOnInit() {
    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        this.isAllowFooter.set(!event.url.includes('auth'));
      }
    });
  }

  ngAfterViewChecked() {
    // this.cdr.detectChanges();
  }

  @HostListener('click', ['$event'])
  clickEvent(event: MouseEvent) {
    if ((event.target as any).type != 'submit') return;

    // (event.target as HTMLButtonElement).setAttribute('disabled', 'true');
    // setTimeout(function () {
    //   (event.target as HTMLButtonElement).removeAttribute('disabled');
    // }, 1000);

    //console.log('event HostListener',  (event.target as any).type,(event.target as any).tagName);

    (event.target as HTMLButtonElement).setAttribute(
      'style',
      'pointer-events: none;',
    );
    setTimeout(function () {
      (event.target as HTMLButtonElement).setAttribute(
        'style',
        'pointer-events: auto;',
      );
    }, 1000);
  }
}
